import api from "../services/api";

function initSideMenu() {
  const body = document.body;
  const menuButton = document.getElementById("side-menu-button");
  const sideMenu = document.getElementById("side-menu");
  const siteOverlay = document.getElementById("site-overlay");

  const sideMenuOpenClass = "side-menu-open";

  sideMenu?.classList.remove("hidden");

  function openMenu(): void {
    body.classList.add(sideMenuOpenClass);
  }

  function closeMenu(): void {
    body.classList.remove(sideMenuOpenClass);
  }

  function isMenuOpen(): boolean {
    return body.classList.contains(sideMenuOpenClass);
  }

  menuButton?.addEventListener("click", openMenu);
  siteOverlay?.addEventListener("click", closeMenu);

  document.addEventListener("keyup", (event) => {
    // Check if escape button is pressed
    if (event.key == "Escape" && isMenuOpen()) {
      closeMenu();
    }
  });

  const anchorMenuItems = document.querySelectorAll("#side-menu a[href]");
  anchorMenuItems.forEach((item) => {
    item.addEventListener("click", closeMenu);
  });

  const expandableItems = document.querySelectorAll(
    "#side-menu [data-expand]"
  ) as NodeListOf<HTMLElement>;

  expandableItems.forEach((item) => {
    const targetId = item.dataset["expand"];

    if (targetId) {
      const target = document.getElementById(targetId);

      if (target) {
        item.addEventListener("click", () => {
          target.classList.toggle("hidden");
          item.classList.toggle("sticky");

          item.querySelectorAll(":scope > [data-expand-icon]").forEach((icon) => {
            icon.classList.toggle("rotate-90");
          });
        });
      }
    }
  });

  const tagUnfollowButtons = document.querySelectorAll(
    "#side-menu button[data-tag-unfollow]"
  ) as NodeListOf<HTMLButtonElement>;

  tagUnfollowButtons.forEach((button) => {
    const tagId = button.dataset["tagId"];
    const tagName = button.dataset["tagName"];
    const linkElement = button.parentNode?.parentNode;

    if (tagId && linkElement) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (confirm(`Are you sure you want to unfollow "${tagName}"?`)) {
          linkElement.parentNode?.removeChild(linkElement);

          api.unfollowTag(tagId).catch((error) => {
            console.error("Error unfollowing tag", tagId, error);
          });
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initSideMenu);
